import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
import App from './App.vue'
import VueGeoLocation from 'vue-browser-geolocation'
import * as VueGoogleMaps from 'vue2-google-maps'
import vueCountryRegionSelect from 'vue-country-region-select'
import VTooltip from 'v-tooltip'
import { auth } from './Firebase'
import router from './routes'
import VModal from 'vue-js-modal'
import VuePapaParse from 'vue-papa-parse'
import Notifications from 'vue-notification'
import Home from './Home.vue'
import NewLayout from './layouts/NewLayout.vue'
import BlankLayout from './layouts/BlankLayout.vue'
import HeaderOnlyLayout from './layouts/HeaderOnlyLayout.vue'
import OutsideClickDirective from './directives'

Vue.config.productionTip = false
Vue.use(VuePapaParse)
Vue.use(AsyncComputed)
Vue.use(VueGeoLocation)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    language: 'EN'
  }
})
Vue.use(vueCountryRegionSelect)
Vue.use(VTooltip)
Vue.use(VModal, { componentName: 'SimpleModal' })
Vue.use(Notifications)

// layouts
Vue.component('default-layout', Home)
Vue.component('new-layout', NewLayout)
Vue.component('blank-layout', BlankLayout)
Vue.component('header-only-layout', HeaderOnlyLayout)
Vue.directive('outside-click', OutsideClickDirective)

let app
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router: router,
      render: (h) => h(App)
    }).$mount('#app')
  }
})
